module.exports = __webpack_public_path__ + "static/media/garment_tag_printer.d26582fe.svg";